import { render, staticRenderFns } from "./rand-money.vue?vue&type=template&id=23bbecbe&"
import script from "./rand-money.vue?vue&type=script&lang=js&"
export * from "./rand-money.vue?vue&type=script&lang=js&"
import style0 from "./rand-money.vue?vue&type=style&index=0&id=23bbecbe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports